import { render } from "./board_batches.vue?vue&type=template&id=39cd9d0c"
import script from "./board_batches.vue?vue&type=script&lang=js"
export * from "./board_batches.vue?vue&type=script&lang=js"

import "./board_batches.vue?vue&type=style&index=0&id=39cd9d0c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__